var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGloves(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M9.6,11.9c-0.9,0-1.7,0.8-1.7,1.7v6.5c0,1.7,0.6,3.4,1.8,4.7v12.6h10.5V24.8c1.2-1.3,1.8-3,1.8-4.7v-3.8 c0-1-0.7-1.7-1.7-1.8c-0.4,0-0.7,0.1-1,0.3v-3.3c0-0.9-0.8-1.7-1.7-1.7c-0.3,0-0.6,0.1-0.9,0.3V9.4c0-1-0.8-1.8-1.8-1.8 c-1,0.1-1.7,0.8-1.7,1.8v0.4c-0.3-0.2-0.6-0.3-0.9-0.3c-0.9,0-1.7,0.8-1.7,1.7c0,0,0,0.1,0,0.1v0.7L9.6,11.9z M11.4,18.4v-7 c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v7h0.8V9.4c-0.1-0.5,0.3-0.9,0.8-1c0,0,0.1,0,0.1,0c0.6,0,1,0.4,1,1v8.9h0.8v-6.9 c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v8.4h0.8v-3.6c0.1-0.5,0.5-0.9,1-0.9c0.5,0,0.9,0.4,0.9,0.9v3.8c0,1.6-0.6,3.1-1.7,4.3h-0.1 v9.5h-6.2v0.9h6.2v1.6h-8.9v-1.5h2v-0.9h-2v-9.5h-0.1c-1.1-1.2-1.7-2.8-1.7-4.4v-6.5c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,1,0.9 v4.8H11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC00",
    d: "M10.6,13.6c-0.1-0.5-0.5-0.9-1-0.9c-0.5,0-0.9,0.4-0.9,0.9v6.5c0,1.6,0.6,3.2,1.7,4.4h0.1v9.5h2v0.9h-2v1.5 h8.9v-1.6h-6.2v-0.9h6.2v-9.5h0.1c1.1-1.2,1.7-2.7,1.7-4.3v-3.8c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-1,0.9v3.6h-0.8v-8.4 c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v6.9h-0.8V9.4c0-0.6-0.4-1-1-1c0,0-0.1,0-0.1,0c-0.5,0.1-0.8,0.5-0.8,1v8.9h-0.8v-7 c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v7h-0.8V13.6z M11.6,32.8h-0.8v-1.8h0.8V32.8z M12.9,32.8h-0.8v-1.8h0.8V32.8z  M14.1,32.8h-0.8v-1.8h0.8V32.8z M15.3,32.8h-0.8v-1.8h0.8V32.8z M16.4,32.8h-0.8v-1.8h0.8V32.8z M17.8,32.8h-0.8v-1.8h0.8V32.8z  M18.9,32.8h-0.8v-1.8h0.8V32.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M30.2,7.7c-0.9,0-1.7,0.8-1.7,1.7c0,0,0,0,0,0v0.6c-0.3-0.2-0.6-0.3-1-0.3c-0.9,0-1.7,0.8-1.7,1.7v3.3 c-0.3-0.2-0.6-0.3-0.9-0.3c-1,0-1.8,0.8-1.8,1.8v3.8c0,1.7,0.7,3.4,1.8,4.7v12.6h10.6V24.8c1.1-1.3,1.7-3,1.7-4.7v-6.5 c0-0.9-0.8-1.7-1.7-1.7l-0.9,0.2v-0.7c0-1-0.8-1.8-1.8-1.8l-0.9,0.3V9.4C31.9,8.5,31.1,7.7,30.2,7.7z M32.8,10.4 c0.5,0,0.9,0.4,1,0.9v7h0.8v-4.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9c0,0,0,0,0,0v6.5c0,1.6-0.6,3.1-1.7,4.3h-0.1v9.5 h-1.9v0.9h1.9v1.6h-8.8v-1.5h6.2v-0.9h-6.2v-9.5h-0.2c-1-1.2-1.6-2.7-1.6-4.3v-3.9c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9 c0,0,0,0,0,0v3.6h0.8v-8.4c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,1,0.9v6.9h0.8V9.4c0-0.5,0.4-0.9,0.9-0.9S31,9,31.1,9.4 c0,0,0,0,0,0v8.9h0.8v-7C31.9,10.9,32.3,10.4,32.8,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC00",
    d: "M31.9,18.4h-0.8V9.4c0,0,0,0,0,0c0-0.5-0.4-0.9-0.9-0.9S29.2,9,29.3,9.4v8.9h-0.8v-6.9 c-0.1-0.5-0.5-0.9-1-0.9c-0.5,0-0.9,0.4-0.9,0.9v8.4h-0.8v-3.6c0,0,0,0,0,0c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v3.9 c0,1.6,0.6,3.1,1.6,4.3h0.2v9.5h6.2v0.9h-6.2v1.5h8.8v-1.6h-1.9v-0.9h1.9v-9.5h0.1c1.1-1.2,1.7-2.7,1.7-4.3v-6.5c0,0,0,0,0,0 c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v4.8h-0.8v-7c-0.1-0.5-0.5-0.9-1-0.9c-0.5,0-0.9,0.4-0.9,0.9V18.4z M26.9,32.8h-0.8 v-1.8h0.8V32.8z M28.1,32.8h-0.8v-1.8h0.8V32.8z M29.4,32.8h-0.8v-1.8h0.8V32.8z M30.6,32.8h-0.8v-1.8h0.8V32.8z M31.8,32.8h-0.8 v-1.8h0.8V32.8z M32.9,32.8h-0.8v-1.8h0.8V32.8z M34.1,32.8h-0.8v-1.8h0.8V32.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.4,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.1,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.3,
    y: 31.1,
    fill: "#FFFFFF",
    width: 0.8,
    height: 1.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGloves);
export default __webpack_public_path__ + "static/media/gloves.ef96923992ae58be2638dce6ddbc3ea2.svg";
export { ForwardRef as ReactComponent };